export enum AddressPropertyEnum {
  COUNTRY = 'country',
  CITY = 'city',
  ZIP = 'zip',
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
}
